import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, HardHat } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/site/Logo";
import { ForgotPassword } from "../components/site/ForgotPassword";

export default function ContractorLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await login(email, password);
      navigate(data.user.role === "admin" ? "/admin" : "/portal");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#EAF7FC] px-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo /></div>
        <div className="rounded-[1.5rem] bg-white p-8 md:p-10 shadow-[0_16px_48px_rgba(19,57,85,0.12)] border border-[rgba(19,57,85,0.06)]">
          <div className="flex items-center gap-3 mb-6">
            <span className="grid place-items-center w-11 h-11 rounded-xl bg-[#133955] text-white"><HardHat size={20} /></span>
            <div>
              <h1 className="font-display text-xl font-bold text-[#133955]">Contractor Portal</h1>
              <p className="text-sm text-[#173042]/60">Sign in to manage your projects</p>
            </div>
          </div>
          <form onSubmit={submit} data-testid="contractor-login-form" className="space-y-4">
            <div>
              <label className="block text-xs font-bold text-[#133955] mb-2 uppercase tracking-wide">Email</label>
              <input data-testid="contractor-email" type="email" className="hpc-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" />
            </div>
            <div>
              <label className="block text-xs font-bold text-[#133955] mb-2 uppercase tracking-wide">Password</label>
              <input data-testid="contractor-password" type="password" className="hpc-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            {error && <p data-testid="contractor-login-error" className="text-sm text-red-600">{error}</p>}
            <button
              type="submit"
              data-testid="contractor-login-submit"
              disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#133955] text-white px-8 py-4 font-bold hover:bg-[#54BCE6] hover:text-[#133955] transition-colors duration-300 disabled:opacity-60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54BCE6]"
            >
              {loading && <Loader2 size={18} className="animate-spin" />}
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
          <div className="mt-4"><ForgotPassword testidPrefix="contractor" defaultEmail={email} /></div>
          <p className="text-xs text-[#173042]/60 mt-5">
            New here? You'll receive an email invite from Home Pro Connect to set your password.
          </p>
        </div>
        <p className="text-center text-sm mt-6"><a href="/" className="text-[#133955] font-semibold hover:underline">← Back to site</a></p>
      </div>
    </div>
  );
}
